module.exports = __webpack_public_path__ + "static/img/logo_jzApp.7af18033.png";